import { Children, createContext, FC, isValidElement, ReactNode, useContext } from 'react';
import { cn } from '@new/lib';

const RowStripeContext = createContext(false);

interface DescriptionListProps {
  children: ReactNode;
  striped?: boolean;
  className?: string;
}

export const DescriptionList: FC<DescriptionListProps> & {
  Row: typeof DescriptionListRow;
} = ({ children, striped = true, className }) => (
  <dl className={cn('divide-y divide-(--neutral-black-NB100) m-0!', className)}>
    {Children.map(children, (child, index) => {
      if (!isValidElement(child)) return child;
      return (
        <RowStripeContext.Provider value={striped && index % 2 === 0}>
          {child}
        </RowStripeContext.Provider>
      );
    })}
  </dl>
);

interface DescriptionListRowProps {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

const DescriptionListRow: FC<DescriptionListRowProps> = ({ label, children, className }) => {
  const striped = useContext(RowStripeContext);

  return (
    <div
      className={cn(
        'px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3',
        striped ? 'bg-(--neutral-white-NW900)' : 'bg-transparent',
        className
      )}
    >
      <dt className="text-sm font-medium text-(--neutral-black-NB1000)">{label}</dt>
      <dd className="mt-1 text-sm text-(--neutral-black-NB800) sm:col-span-2 sm:mt-0">
        {children}
      </dd>
    </div>
  );
};

DescriptionList.Row = DescriptionListRow;
